module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/_babel-runtime@5.8.38@babel-runtime/core-js/promise.js
// module id = 374
// module chunks = 0